// Habillage de l'onglet en préprod : titre préfixé et favicon rayé. Décidé
// par l'environnement que renvoie l'API (/api/features, le même indicateur
// que le bandeau), jamais par le nom d'hôte.

export const PREPROD_TITLE_PREFIX = '[PRÉPROD] ';
export const PREPROD_FAVICON = '/favicon-preprod.svg';

/** Préfixe le titre, sans jamais le doubler. */
export function prefixTitle(title: string): string {
  return title.startsWith(PREPROD_TITLE_PREFIX) ? title : PREPROD_TITLE_PREFIX + title;
}

/** Retire le préfixe (retour à l'habillage de prod). */
export function unprefixTitle(title: string): string {
  return title.startsWith(PREPROD_TITLE_PREFIX) ? title.slice(PREPROD_TITLE_PREFIX.length) : title;
}

/**
 * Pose l'habillage préprod sur le document et le maintient : une page qui
 * change son titre (ex. Aide à la connexion) le retrouve préfixé. Renvoie de
 * quoi tout remettre comme avant.
 */
export function applyPreprodChrome(doc: Document): () => void {
  const icon = doc.querySelector<HTMLLinkElement>('link[rel~="icon"]');
  const iconHref = icon?.getAttribute('href') ?? null;
  if (icon) icon.setAttribute('href', PREPROD_FAVICON);

  const fix = () => {
    const next = prefixTitle(doc.title);
    if (next !== doc.title) doc.title = next;
  };
  fix();

  // Observe <head> : React ou une page peut remplacer le texte du <title>.
  const observer = new MutationObserver(fix);
  observer.observe(doc.head, { subtree: true, childList: true, characterData: true });

  return () => {
    observer.disconnect();
    doc.title = unprefixTitle(doc.title);
    if (icon && iconHref !== null) icon.setAttribute('href', iconHref);
  };
}
